<template>
	<valuation-layout>
		<valuation-model-stepper slot="stepper" :current-step="1" />
		<valuation-model-factor-list
			:factor-list="factorList"
			:selected-factors="selectedFactors"
			@factorSelected="onFactorClick"
			slot="content"
		/>
		<valuation-model-description-navigation
			slot="description"
			:next-is-enabled="hasValidFactors"
		/>
	</valuation-layout>
</template>

<script>
import ValuationModelFactorList
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelFactorList';
import ValuationModelStepper
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/ValuationModelStepper';
import ValuationModelDescriptionNavigation
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation';
import { mapState } from 'vuex';
import { __, append, ifElse, pathOr, propEq, reject } from 'ramda';
import ValuationLayout from '@/modules/job-evaluation/components/supplies/valuation-model/commons/ValuationLayout';
import { factorIsSelected } from '../../../../utils/valuation-model/factors';

export default {
	name: 'FactorsChoicePage',
	components: {
		ValuationLayout,
		ValuationModelFactorList,
		ValuationModelStepper,
		ValuationModelDescriptionNavigation,
	},
	mounted() {
		this.$store.dispatch('jobEvaluation/getFactors');
	},
	computed: {
		...mapState('jobEvaluation', {
			factorList: pathOr([], ['supplies', 'valuationModel', 'factorList']),
			selectedFactors: pathOr([], ['supplies', 'valuationModel', 'selectedFactors']),
			quantityFactor: pathOr([], ['mainData', 'config', 'stages', 0, 'details', 2, 'quantityFactor']),
		}),
		hasValidFactors() {
			return this.selectedFactors.length >= this.quantityFactor;
		},
	},
	methods: {
		onFactorClick(factor) {
			const newSelectedFactors = ifElse(
				factorItem => factorIsSelected(this.selectedFactors, factorItem),
				factorItem => reject(propEq('name', factorItem.name), this.selectedFactors),
				append(__, this.selectedFactors),
			)(factor);
			this.$store.dispatch('jobEvaluation/updateSelectedFactors', newSelectedFactors);
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/valuation-model/step-pages/FactorsChoicePage.vue